// 获取浏览器类型
export const getUA = () => {
  let ua = typeof document !== 'undefined' ? window?.navigator?.userAgent : ''
  ua = ua?.toLowerCase()
  return ua
}

// 获取casId
export const getCasId = () => {
  const userInfo = localStorage.userInfo
    ? JSON.parse(localStorage.userInfo)
    : ''
  return userInfo.id || ''
}
